import { Component, inject, OnDestroy } from '@angular/core';
import { CostPlanFormComponent } from './cost-plan-form/cost-plan-form.component';
import { CostPlanHeaderComponent } from './cost-plan-header/cost-plan-header';
import { CostPlanSubmissionComponent } from './cost-plan-submission/cost-plan-submission.component';
import { CommonModule, ViewportScroller } from '@angular/common';
import { first, Observable, Subject, takeUntil } from 'rxjs';
import { CanComponentDeactivate } from '../../utils/can-component-deactivate.interface';
import { PlanFormStatus } from './types';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'cost-plan-component',
    standalone: true,
    imports: [CommonModule, CostPlanFormComponent, CostPlanHeaderComponent, CostPlanSubmissionComponent, DialogModule, ToastModule],
    templateUrl: './cost-plan-component.html',
    styleUrl: './cost-plan-component.less',
    providers: [MessageService],
})
export class CostPlanComponent implements CanComponentDeactivate, OnDestroy {
    isSubmitted: boolean = false;
    showUnsubmitTip: boolean = false;
    private isTouched: boolean = false;
    private submitFn?: () => void;
    private subject: Subject<boolean> = new Subject<boolean>();
    private observer!: Observable<boolean>;

    private viewportScroller = inject(ViewportScroller);

    private destroy$: Subject<void> = new Subject<void>();

    canDeactivate(): boolean | Observable<boolean> {
        if (this.isTouched && !this.isSubmitted) {
            this.showUnsubmitTip = true;
            this.observer = this.subject.asObservable().pipe(takeUntil(this.destroy$)).pipe(first());
            return this.observer;
        }
        return true;
    }

    handleSubmit() {
        this.showUnsubmitTip = false;
        this.subject.next(false);
        if (this.submitFn) {
            this.submitFn();
        }
    }

    handleCancel() {
        this.showUnsubmitTip = false;
        this.subject.next(true);
    }

    handleClose(): void {
        if (this.observer) {
            this.subject.next(false);
        }
    }

    formStatusUpdate($event: PlanFormStatus) {
        this.isSubmitted = $event.isSubmitted;
        this.isTouched = $event.isTouched;
        this.submitFn = $event.submitFn;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
